import React from "react";
import { ExternalLink, BadgeCheck } from "lucide-react";
import { DIREKTORIBIZ_URL } from "@/lib/constants";

export const DirektoriBizBanner = () => (
  <section
    className="max-w-6xl mx-auto px-4 sm:px-6 my-16 sm:my-24"
    data-testid="direktoribiz-banner"
    aria-labelledby="direktoribiz-heading"
  >
    <div className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-[#0F3F2F] via-[#125943] to-[#0B2A20] text-white px-6 py-10 sm:px-12 sm:py-14">
      <div className="absolute -top-16 -right-12 h-56 w-56 rounded-full bg-[#E3B84B]/20" />
      <div className="absolute -bottom-20 -left-10 h-52 w-52 rounded-full bg-emerald-400/15" />
      <div className="relative max-w-2xl">
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold tracking-wide text-[#F3E2B6]">
          <BadgeCheck strokeWidth={1.5} className="h-4 w-4" />
          Manfaat Tambahan
        </span>
        <h2 id="direktoribiz-heading" className="mt-5 text-2xl sm:text-3xl font-bold tracking-tight">
          Tempah Kad Perniagaan &amp; Nikmati Penyenaraian Perniagaan PERCUMA
        </h2>
        <p className="mt-4 text-sm sm:text-base text-emerald-50/85 leading-relaxed">
          Setiap tempahan kad perniagaan layak mendapat penyenaraian percuma di
          DirektoriBiz.My.
        </p>
        <a
          href={DIREKTORIBIZ_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="banner-direktoribiz-cta"
          className="mt-7 inline-flex items-center gap-2 rounded-full bg-[#E3B84B] px-6 py-3 text-sm font-semibold text-[#0B2A20] hover:bg-[#F0C963] hover:-translate-y-[1px] transition-[background-color,transform] duration-200"
        >
          Lihat DirektoriBiz.My
          <ExternalLink strokeWidth={1.75} className="h-4 w-4" />
        </a>
      </div>
    </div>
  </section>
);
